<template>
  <div class="infoLine flex">
    <div class="infoTitle">详细地址</div>
    <div class="infoText flex1" style="position: relative">
      <input disabled="disabled" v-model="label" />
      <popup-picker
        class="myPicker"
        :data="cityData"
        :columns="3"
        v-model="cityValue"
        ref="picker"
        @on-show="showPop"
        @on-change="change"
      ></popup-picker>
    </div>
  </div>
</template>

<script>
import { PopupPicker } from "vux";
import { getLocationList } from "../../api/address";
export default {
  name: "address",
  components: {
    PopupPicker
  },
  props: ["value"],
  data() {
    return {
      orginList: "",
      label: "",
      cityData: [],
      cityValue: ["", "", ""]
    };
  },
  watch: {
    value(e) {
      let that = this;
      setTimeout(function() {
        that.getLabel(e);
      }, 500);
    }
  },
  created() {
    this.getLocationList();
  },
  methods: {
    showPop() {
      this.cityValue = [
        this.value.substr(0, 2),
        this.value.substr(0, 4),
        this.value
      ];
    },
    change(e) {
      this.cityValue = e;
      this.getLabel(e[2]);
    },
    getLocationList() {
      getLocationList()
        .then(res => {
          this.orginList = res;
          this.handleRegion(res);
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getLabel(code) {
      if (code) {
        for (let i = 0; i < this.orginList.length; i++) {
          if (this.orginList[i].children) {
            for (let x = 0; x < this.orginList[i].children.length; x++) {
              for (
                let y = 0;
                y < this.orginList[i].children[x].children.length;
                y++
              ) {
                if (this.orginList[i].children[x].children[y].id == code) {
                  let label =
                    this.orginList[i].title +
                    "-" +
                    this.orginList[i].children[x].title +
                    "-" +
                    this.orginList[i].children[x].children[y].title;
                  this.label = label;
                  this.$emit(
                    "input",
                    this.orginList[i].children[x].children[y].id
                  );
                }
              }
            }
          }
        }
      }
    },
    handleRegion(region) {
      for (let i = 0; i < region.length; i++) {
        if (region[i].children) {
          this.cityData.push({
            name: region[i].title,
            value: region[i].id,
            parent: region[i].parentId
          });
          for (let x = 0; x < region[i].children.length; x++) {
            this.cityData.push({
              name: region[i].children[x].title,
              value: region[i].children[x].id,
              parent: region[i].children[x].parentId
            });
            for (let y = 0; y < region[i].children[x].children.length; y++) {
              this.cityData.push({
                name: region[i].children[x].children[y].title,
                value: region[i].children[x].children[y].id,
                parent: region[i].children[x].children[y].parentId
              });
            }
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.myPicker {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  opacity: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
input {
  width: 100%;
  border: none;
  background: #fff;
}
.infoLine {
  overflow: hidden;
  padding: 30px;
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
}

.infoTitle {
  width: 140px;
  font-size: 14px;
  line-height: 30px;
  color: #525252;
}
.infoText {
  text-align: right;
  font-size: 14px;
  line-height: 28px;
  color: #262626;
}

.infoText input {
  line-height: 28px;
  font-size: 14px;
  width: 100%;
  text-align: right;
}
</style>
